<template>
  <div class="appointmentList-view">
    <div class="flex-a-c mb40 mt70">
      <div class="fs7 fwbold cA1 w300 ">1、{{ $t('business', 'assessmentRuleName') }}:</div>
      <el-input
          type="text"
          :placeholder="$t('business', 'pleaseEnterContent')"
          v-model="rulesTitle"
          maxlength="10"
          style="width: 300px"
          show-word-limit
        >
        </el-input>
    </div>
    <div class="flex-a-c mb40">
      <div class="fs7 fwbold cA1 w300 ">2、{{ $t('business', 'assessmentTimeCycle') }}:</div>
      <el-date-picker
        v-if="!kpiId"
        class="w300"
        
        v-model="createTime"
        type="daterange"
        :start-placeholder="$t('business', 'startDate')"
        :end-placeholder="$t('business', 'endDate')">
      </el-date-picker>
      <el-date-picker
        v-else
        class="w340"
        v-model="createTime"
        :disabled="true"
        type="daterange"
        :start-placeholder="start"
        :end-placeholder="end">
      </el-date-picker>
    </div>
    <div class="flex-a-c mb40">
      <div class="fs7 fwbold cA1 w300 ">3、{{ $t('business', 'assessmentObject') }}:</div>
      <div class="d-flex" v-if="nameList.length !== 0">
        <div class="d-flex mr30" 
             style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;width:220px;">
          
          {{ nameString }}
        </div>
      </div>
      
      <el-button
          class="v-primary"
          type="primary"
          @click="addRulesMember"
          >{{ $t('business', 'pleaseSelect') }}</el-button
        >
    </div>
    <div class="flex-a-c mb40">
      <div class="fs7 fwbold cA1 w300 ">4、{{ $t('business', 'assessmentContent') }}:</div>
      <el-button
          class="v-primary"
          type="primary"
          @click="addRules"
          >{{ruleContent.length == 0 ? $t('business', 'add') : $t('business', 'edit')}}</el-button
        >
    </div>
    
    <div class="d-flex flex-column mb40">
      <div style="margin-left:300px" 
           v-for="(item,index) in ruleContent" 
           :key="index">
        <div class="flex-a-c mb20" v-if="item.type == 1">
          <div class="w200">{{ $t('business', 'addCustomerCount') }}</div>
          <div class="flex-a-c">
            <el-input
              type="number"
              placeholder="1~9999999"
              oninput="value=value.replace(/[^\d]/g,'')"
              v-model="item.value"
              max="9999999"
              min="1"
              style="width: 120px"
              @change="() => {
                item.value =  (item.value > 9999999 || item.value == 0 ) ? '' : item.value
              }"
            >
            </el-input><span class="unit-gap">{{ $t('business', 'unit') }}</span>
            <i class="el-icon-delete ml20" @click="deleteBtn(item,index)"></i>
          </div>
        </div>
        <div class="flex-a-c mb20" v-if="item.type == 2">
          <div class="w200">{{ $t('business', 'newUserVisitorCount') }}</div>
          <div class="flex-a-c">
            <el-input
              type="number"
              placeholder="1~9999999"
              oninput="value=value.replace(/[^\d]/g,'')"
              v-model="item.value"
              max="9999999"
              min="1"
              style="width: 120px"
              @change="() => {
                item.value =  (item.value > 9999999 || item.value == 0 ) ? '' : item.value
              }"
            >
            </el-input><span class="unit-gap">{{ $t('business', 'unit') }}</span>
            <i class="el-icon-delete ml20" @click="deleteBtn(item,index)"></i>
          </div>
        </div>
        <div class="flex-a-c mb20" v-if="item.type == 3">
          <div class="w200">{{ $t('business', 'customerFollowUpRate') }}</div>
          <div class="flex-a-c">
            <el-input
              type="number"
              placeholder="1~100"
              v-model="item.value"
              max="100"
              min="1"
              oninput="value=value.replace(/[^\d]/g,'')"
              style="width: 120px"
              @change="() => {
                item.value =  (item.value > 100 || item.value == 0 ) ? '' : item.value
              }"
            >
            </el-input><span class="unit-gap">{{ $t('business', 'percentage') }}</span>
            <i class="el-icon-delete ml20" @click="deleteBtn(item,index)"></i>
          </div>
        </div>
        <div class="flex-a-c mb20" v-if="item.type == 4">
          <div class="w200">{{ $t('business', 'mallSalesAmount') }}</div>
          <div class="flex-a-c">
            <el-input
              type="number"
              placeholder="1~9999999"
              oninput="value=value.replace(/[^\d]/g,'')"
              v-model="item.value"
              max="9999999"
              min="1"
              style="width: 120px"
              @change="() => {
                item.value =  (item.value > 9999999 || item.value == 0 ) ? '' : item.value
              }"
            >
            </el-input><span class="unit-gap">{{ $t('business', 'yuan') }}</span>
            <i class="el-icon-delete ml20" @click="deleteBtn(item,index)"></i>
          </div>
        </div>
        
      </div>
      
      <el-button
          class="v-primary w100"
          type="primary"
          width=""
          @click="publish"
          >{{ $t('business', 'publish') }}</el-button>
      
    </div>

    <!-- 部门成员列表 -->
    <el-dialog
          class="label_dialog"
          :title="$t('business', 'selectAssessmentObject')"
          width="50%"
          center
          :visible.sync="editVisible"
          :modal-append-to-body="false"
          @closed="editVisible = false"
        >
        <div class="w100p flex-a-b-c mb50">
          <el-checkbox class="" v-if="memberList.length !== 0 " v-model="checkAllMember" @change="checkAllMemberBox_tap">{{ $t('business', 'selectAll') }}</el-checkbox>
          <span v-else></span>
          <div class="flex-a-c">
            <el-select
              v-model="currentDepartment"
              style="width: 150px;margin-right:20px"
              :placeholder="$t('business', 'pleaseSelectDepartment')"
            >
              <el-option
                v-for="(item) in departmentList"
                :key="item.departmentId"
                :label="item.name"
                :value="item.departmentId"
              />
            </el-select>
            <el-input
              type="text"
              :placeholder="$t('business', 'pleaseEnterEmployeeName')"
              v-model="departmentKey"
              style="width: 150px; margin-right:30px">
            </el-input>
            <el-button
                class="v-primary"
                style=""
                type="primary"
                @click="queryPageMember"
                >{{ $t('business', 'search') }}</el-button>
          </div>
          
        </div>
        
        <div class="flex-a-c flex-wrap-y mb30" v-if="memberList.length !== 0">
          <el-checkbox-group  v-model="checkedMemberArr">
          <el-checkbox  class="mr30 mb30"
                        style="margin-left: 0"
                        v-for="(item, index) in memberList"
                        :key="index"
                        @change="checkbox_tap"
                        :label="item.empId"
                        border
                        >{{ item.employeeName }}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="flex-c-c mb30" v-else-if="!currentDepartment">
          <p>{{ $t('business', 'pleaseSelectDepartmentFirst') }}</p>
        </div>
        <div class="flex-c-c mb30" v-else>
          <p>{{hintText}}</p>
        </div>
        
        <div class="w100p mt50 d-flex justify-content-center">
          <el-pagination
              background
              @current-change="currentChange"
              :current-page="currentPage"
              :page-size="25"
              layout="total, prev, pager, next"
              :total="productList.length"
            />
        </div>
        <div class="d-flex justify-content-center">
          <div class="w100 mt50 d-flex justify-content-center">
            <el-button
              class="v-primary"
              style="margin-right: 20px"
              type="primary"
              @click="editVisible = false"
              >{{ $t('business', 'cancel') }}</el-button
            >
            <el-button
              class="v-primary"
              type="primary"
              @click="saveMemberContent"
              >{{ $t('business', 'confirm') }}</el-button
            >
          </div>
        </div>
        
        
    </el-dialog>
    <!-- 规则列表 -->
    <el-dialog
          class="label_dialog "
          :title="$t('business', 'selectRules')"
          width="400px"
          center
          :visible.sync="rulesVisible"
          :modal-append-to-body="false"
          @closed="rulesVisible = false"
        >
        <div class="d-flex flex-column flex-wrap-y mb30 pl50">
          <el-checkbox class="mb30" v-model="checkAll" @change="checkAllBox_tap">{{ $t('business', 'selectAll') }}</el-checkbox>
          <el-checkbox-group  class="d-flex flex-column" 
                              v-model="checkedArr">
            <el-checkbox  class="mr30 mb30"
                          style="margin-left: 0"
                          v-for="(item, index) in checkedRules"
                          :key="index"
                          @change="checkbox_tap(index)"
                          :label="item.empId"
                          >{{ item.title }}</el-checkbox>
          </el-checkbox-group>
        </div>

        <el-button
          class="v-primary ml10"
          style="margin-left:150px !important"
          type="primary"
          @click="saveRuleContent"
          >{{ $t('business', 'save') }}</el-button>
    </el-dialog>
  </div>
</template>

<script>
import {
  queryPageEmployee,
  queryPageDepartment
} from "@/api/companyManage.js";
import {
  addEmployeeKpi,
  getEmployeeKpiDetails
} from "@/api/employee.js";
import { getDataTimeSec } from "@/utils";
import i18nMixin from '@/mixins/i18nMixin'


export default {
  name: "appointmentList",
  mixins: [i18nMixin],
  data() {
    return {
      rulesTitle:'',
      createTime:'',
      start:'',
      end:'',
      editVisible:false,
      rulesVisible:false,
      checkedArr:[], //当前页显示内容
      checkedMemberArr:[], //选中的成员
      memberList:[], // 成员列表
      checkAll:false, //考核规则全选
      checkAllMember:false,// 全选成员
      checkedRules:[
        {
          title: this.$t ? this.$t('business', 'addCustomerCount') : "添加客户数",
          type:1,
          empId:1
        },
        {
          title: this.$t ? this.$t('business', 'newUserVisitorCount') : "新用户访问数",
          type:2, 
          empId:2
        },
        {
          title: this.$t ? this.$t('business', 'customerFollowUpRate') : "客户跟进率",
          type:3,
          empId:3
        },
        {
          title: this.$t ? this.$t('business', 'mallSalesAmount') : "商城销售金额",
          type:4,
          empId:4
        }
      ],
      ruleContent:[], //选好的考核规则
      memberContent:[], //选好的考核人员
      productList:[], //所有数据
      totalPage: 1, // 统共页数，默认为1
      currentPage: 1, //当前页数 ，默认为1
      pageSize: 25, // 每页显示数量
      currentPageData: [], //当前页显示内容
      departmentList:"",//部门数据
      currentDepartment:"",//选择的当前部门
      departmentKey:'',// 部门搜索关键字
      hintText:'', //提示文字
      nameList:[],
      isLoading:false,
      kpiId:''
    };
  },
  watch:{
    createTime(val,old){
      this.start =  getDataTimeSec(this.createTime[0], 'yy-mm-dd') +" 00:00:00"
      this.end = getDataTimeSec(this.createTime[1], 'yy-mm-dd') +" 23:59:59" 
      
      console.log(this.end)
    },
    checkedArr(val,old){
      if(val.length == 4){
        this.checkAll = true
      }else{
        this.checkAll = false
      }
    },
    checkedMemberArr(val,old){
      console.log(val)
      if(val.length == this.productList.length){
        this.checkAllMember = true
      }else{
        this.checkAllMember = false
      }
    },
    currentDepartment(val,old){
      console.log(val)
    },
    // 监听语言变化，强制更新组件
    currentLanguage() {
      this.$forceUpdate();
      this.updateCheckedRules();
    }
  },
  created() {
    console.log()
    if(this.$route.query.id){
      this.kpiId = this.$route.query.id
      this.queryEmployeeKpiDetails()
    }
  },
  
  computed:{
     nameString () {
       let names =  '' 
       this.nameList.forEach((item,index)=>{
         names +=  item.name+'、'
       })
       if(names.length > 15){
         names = names.slice(0,10) + '...(' +  (this.nameList.length + '人)')
       }
       return  names
     }
  },
  mounted(){
    this.queryPageMember()
    this.updateCheckedRules();
  },
  methods: {
    // 更新checkedRules的标题
    updateCheckedRules() {
      this.checkedRules = [
        {
          title: this.$t('business', 'addCustomerCount'),
          type: 1,
          empId: 1
        },
        {
          title: this.$t('business', 'newUserVisitorCount'),
          type: 2,
          empId: 2
        },
        {
          title: this.$t('business', 'customerFollowUpRate'),
          type: 3,
          empId: 3
        },
        {
          title: this.$t('business', 'mallSalesAmount'),
          type: 4,
          empId: 4
        }
      ];
    },
    // 设置当前页面数据，对数组操作的截取规则为[0~10],[10~20]...,
    setCurrentPageData() {
        let begin = (this.currentPage - 1) * this.pageSize;
        let end = this.currentPage * this.pageSize;
        this.memberList = this.productList.slice(
            begin,
            end
        );
    },
    addRulesMember(item){
      this.editVisible = true
      let data = {
        pageSize:9999,
      }
      queryPageDepartment(data)
      .then(res=>{
        this.departmentList = res.data?.pageInfo?.list
        console.log(this.departmentList)
        this.departmentList.unshift({
          departmentId:'',
          name: this.$t('business', 'selectAll')
        })
      })
    },
    queryPageMember(){
      let data = {
        pageSize:9999,
        departmentId:this.currentDepartment,
        name:this.departmentKey,
      }
      queryPageEmployee(data)
      .then(res=>{
        console.log(res)
        if(res.data && res.data.pageInfo && res.data.pageInfo.list){
          
          this.productList = res.data.pageInfo.list
          this.setCurrentPageData()
        }else{
          this.productList = []
          this.memberList = []
          this.hintText = this.$t('business', 'noData')
        }
        
      })
      .catch(res=>{
        this.hintText = this.$t('business', 'noData')
      })
    },
    addRules(){
      this.rulesVisible = true
    },
    //设置checkbox选择状态
    checkbox_tap(val){
      console.log('val',val)
      
    },
    checkAllBox_tap(val){
      let than = this
      if(val){
        than.checkedArr = []
        than.checkedRules.forEach((item,index)=>{
          than.checkedArr.push(item.empId)
        })
      }else{
        than.checkAll = true
          than.checkedArr = []
      }
    },
    saveRuleContent(){
      this.rulesVisible = false
      this.ruleContent = JSON.parse(JSON.stringify(this.checkedArr)) 
      this.ruleContent = this.ruleContent.map((item,index)=>{
        return {
          type:item,
          value:''
        }
      })
    },
    saveMemberContent(){
      let than = this
      than.editVisible = false
      
      than.memberContent = JSON.parse(JSON.stringify(than.checkedMemberArr))
      than.nameList = []
      for(var i in this.memberContent){
        than.productList.forEach((item,index)=>{
          if(this.memberContent[i] == item.empId){
            than.nameList.push({
              name:item.employeeName
            })
          } 
          
        })
      }
    },

    deleteBtn(item,index){
      for(var i in this.checkedArr){
        if(this.checkedArr[i] == item.type){
          this.checkedArr.splice(i,1)
        }
      }
      this.ruleContent.splice(index,1)
    },
    currentChange(val){
      this.currentPage = val
      this.setCurrentPageData()
    },
    checkAllMemberBox_tap(val){
      let than = this
      if(val){
        than.checkedMemberArr = []
        than.productList.forEach((item,index)=>{
          than.checkedMemberArr.push(item.empId)
        })
      }else{
        than.checkAllMember = false
        than.checkedMemberArr = []
      }
    },
    publish(){
      if( !this.rulesTitle ||  !this.start  || !this.end || this.ruleContent.length == 0 || this.memberContent.length == 0){
        
        return this.$message.error(this.$t('business', 'pleaseCompleteRuleContent'))
      }
      for(var i in this.ruleContent){
        if(!this.ruleContent[i].value){
          return this.$message.error(this.$t('business', 'pleaseCompleteAssessmentContent'))
        }
      }
      
      let data = {
        name:this.rulesTitle,
        startTime:this.start,
        endTime:this.end,
        rules:JSON.stringify(this.ruleContent),
        employees:'',
        kpiId:this.kpiId
      }
      
      this.memberContent.forEach((item,index)=>{
        data.employees += item + ','
      })
      console.log(data.employees)
      addEmployeeKpi(data)
      .then(res=>{
        console.log(res)
        if(res.code == 200){
          this.$message.success(this.$t('business', 'addSuccess'))
          this.$router.go(-1)
        }
      })
      .catch(err=>{
        console.log(err)
      })
    },
    //获取详情
    queryEmployeeKpiDetails(){
      let data ={
        kpiId:this.kpiId
      }
      getEmployeeKpiDetails(data)
      .then((res)=>{
        let kpidata = res.data.employee_kpi
        this.rulesTitle = kpidata.name
        this.start = kpidata.startTime
        this.end = kpidata.endTime
        this.ruleContent = kpidata.rules
        this.checkedArr = this.ruleContent.map((item,index)=>{
          return item.type
        })

        this.checkedMemberArr = kpidata.employees.map((item,index)=>{
          return item.empId
        })
        this.nameList = kpidata.employees.map((item,index)=>{
          return {
            name:item.nickeName
          }
        })
        this.memberContent = kpidata.employees.map((item,index)=>{
          return item.empId
        })

      })
    }
  },
};
</script>

<style lang="scss" scoped>
.appointmentList-view{
  background: #ffffff;
  padding: 24px;
}
/deep/ .el-dialog__body{
  padding: 50px 50px 60px;
}
.unit-gap{
  margin-left: 8px;
}
</style>